import axios from "axios";

export default axios.create({
  baseURL: `https://api3.up-it.rs/api`,
  withCredentials: true,
});
